import { registerLibrary } from '@onviobr/app-info';
import _indexOfInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/index-of';
import _spliceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/splice';
import _findInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/find';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _createForOfIteratorHelper from '@babel/runtime-corejs3/helpers/createForOfIteratorHelper';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import 'core-js/modules/es.regexp.constructor';
import 'core-js/modules/es.regexp.exec';
import 'core-js/modules/es.regexp.to-string';
import _URL from '@babel/runtime-corejs3/core-js-stable/url';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import 'core-js/modules/es.object.to-string';
import 'core-js/modules/es.promise';
import _regeneratorRuntime from '@babel/runtime-corejs3/regenerator';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import 'regenerator-runtime/runtime';
import _asyncToGenerator from '@babel/runtime-corejs3/helpers/asyncToGenerator';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import '@babel/runtime-corejs3/core-js-stable/instance/concat';
import '@babel/runtime-corejs3/core-js-stable/object/entries';
import '@babel/runtime-corejs3/core-js-stable/instance/entries';
import '@babel/runtime-corejs3/helpers/toConsumableArray';
import '@babel/runtime-corejs3/core-js-stable/array/is-array';
import _objectSpread from '@babel/runtime-corejs3/helpers/objectSpread2';
import _Symbol from '@babel/runtime-corejs3/core-js-stable/symbol';
import { get } from '@onviobr/external-injector';
import 'core-js/modules/es.array.join';
import 'core-js/modules/es.string.split';
import _reduceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/reduce';

function domainIsAllowed(domain) {
  var _context;

  var list = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (list.length === 0) {
    return true;
  }

  return _filterInstanceProperty(_context = _mapInstanceProperty(list).call(list, function (rule) {
    return rule instanceof RegExp ? rule.test(domain) : rule === domain;
  })).call(_context, function (result) {
    return result;
  }).length > 0;
}

function isAllowed(domain, resource) {
  return domainIsAllowed(domain, resource.domainAllowList);
}
function getDomainFromURL(url) {
  return new _URL(url, window.location.href).host;
}

var inputInterceptors = [];
var requestInterceptors = [];
var rejectInterceptors = [];
var resolveInterceptors = [];
var originalFetch;

function interceptor(_x) {
  return _interceptor.apply(this, arguments);
}

function _interceptor() {
  _interceptor = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
    var _context;

    var options,
        inputInter,
        _iterator,
        _step,
        _interceptor2,
        _interceptor2$resourc,
        _interceptor2$resourc2,
        _input,
        _options,
        request,
        _context2,
        _response,
        _context3,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};

            if (options.body === null) {
              delete options.body;
            }

            inputInter = _filterInstanceProperty(inputInterceptors).call(inputInterceptors, function (int) {
              return isAllowed(getDomainFromURL(input instanceof Request ? input.url : input), int);
            });
            _iterator = _createForOfIteratorHelper(inputInter);

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                _interceptor2 = _step.value;
                _interceptor2$resourc = _interceptor2.resource(input, options), _interceptor2$resourc2 = _slicedToArray(_interceptor2$resourc, 2), _input = _interceptor2$resourc2[0], _options = _interceptor2$resourc2[1];
                input = _input;
                options = _options !== null && _options !== void 0 ? _options : options;
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            if (options.body === null) {
              delete options.body;
            }

            request = new Request(input, options);

            _mapInstanceProperty(_context = _filterInstanceProperty(requestInterceptors).call(requestInterceptors, function (int) {
              return isAllowed(getDomainFromURL(request.url), int);
            })).call(_context, function (int) {
              return int.resource(request);
            });

            _context4.prev = 8;
            _context4.next = 11;
            return originalFetch(request);

          case 11:
            _response = _context4.sent;

            _mapInstanceProperty(_context2 = _filterInstanceProperty(resolveInterceptors).call(resolveInterceptors, function (int) {
              return isAllowed(getDomainFromURL(request.url), int);
            })).call(_context2, function (int) {
              return int.resource(_response, request);
            });

            return _context4.abrupt("return", _response);

          case 16:
            _context4.prev = 16;
            _context4.t0 = _context4["catch"](8);

            _mapInstanceProperty(_context3 = _filterInstanceProperty(rejectInterceptors).call(rejectInterceptors, function (int) {
              return isAllowed(getDomainFromURL(request.url), int);
            })).call(_context3, function (int) {
              return int.resource(_context4.t0, request);
            });

            throw _context4.t0;

          case 20:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee, null, [[8, 16]]);
  }));
  return _interceptor.apply(this, arguments);
}

function intercept() {
  if (window.fetch !== interceptor) {
    originalFetch = window.fetch;
    window.fetch = interceptor;
  }
}

function release() {
  window.fetch = originalFetch;
}

function isIntercepted() {
  return window.fetch === interceptor;
}

function releaseIfNotUsed() {
  if (requestInterceptors.length === 0 && rejectInterceptors.length === 0 && resolveInterceptors.length === 0) {
    release();
  }
}

function safeAdd(fn, list, domainAllowList) {
  intercept();
  list.push({
    resource: fn,
    domainAllowList: domainAllowList
  });
  return function () {
    var int = _findInstanceProperty(list).call(list, function (int) {
      return int.resource === fn;
    });

    if (int) {
      _spliceInstanceProperty(list).call(list, _indexOfInstanceProperty(list).call(list, int), 1);
    }

    releaseIfNotUsed();
  };
}

function addInputInterceptor(fn, domainAllowList) {
  return safeAdd(fn, inputInterceptors, domainAllowList);
}
function addRequestInterceptor(fn, domainAllowList) {
  return safeAdd(fn, requestInterceptors, domainAllowList);
}
function addRejectInterceptor(fn, domainAllowList) {
  return safeAdd(fn, rejectInterceptors, domainAllowList);
}
function addResolveInterceptor(fn, domainAllowList) {
  return safeAdd(fn, resolveInterceptors, domainAllowList);
}

function headersToObject(headers) {
  var result = {};
  var inter = new Headers(headers);

  _forEachInstanceProperty(inter).call(inter, function (value, key) {
    result[key.toLowerCase()] = value;
  });

  return result;
}

function noop() {}

var headersSets = [];
var interceptorReleaser;

function resolveHeaderValue(value, request) {
  return typeof value === 'function' ? value(request, headersToObject(request.headers || {})) : value;
}

function interceptor$1(request) {
  var headersSetsToApply = _filterInstanceProperty(headersSets).call(headersSets, function (set) {
    return isAllowed(getDomainFromURL(request.url), set);
  });

  var _iterator = _createForOfIteratorHelper(headersSetsToApply),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var set = _step.value;

      for (var _key in set.resource) {
        if (Object.prototype.hasOwnProperty.call(set.resource, _key)) {
          var h = _key.toLowerCase();

          var value = resolveHeaderValue(set.resource[_key], request);

          if (value !== null && value !== undefined) {
            request.headers.set(h, value);
          } else if (value === null && request.headers.has(h)) {
            request.headers.delete(h);
          }
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

function intercept$1() {
  if (!interceptorReleaser) {
    interceptorReleaser = addRequestInterceptor(interceptor$1);
  }
}

function release$1() {
  if (interceptorReleaser) {
    interceptorReleaser();
    interceptorReleaser = null;
  }
}

var isEmpty = function isEmpty(obj) {
  return obj === undefined || obj === null || _Object$keys(obj).length === 0;
};

function injectFetchHeaders(headers, domainAllowList) {
  if (isEmpty(headers)) {
    return noop;
  }

  intercept$1();
  headersSets.push({
    resource: headers,
    domainAllowList: domainAllowList
  });
  return function () {
    var int = _findInstanceProperty(headersSets).call(headersSets, function (int) {
      return int.resource === headers;
    });

    if (int) {
      _spliceInstanceProperty(headersSets).call(headersSets, _indexOfInstanceProperty(headersSets).call(headersSets, int), 1);
    }

    if (headersSets.length === 0) {
      release$1();
    }
  };
}

function eventEmitter() {
  var eventTarget;

  try {
    eventTarget = new EventTarget();
  } catch (_) {
    eventTarget = document.createElement('a');
  }

  var on = function on(type, listener, options) {
    eventTarget.addEventListener(type, listener, options);
  };

  var off = function off(type, listener) {
    eventTarget.removeEventListener(type, listener);
  };

  var emit = function emit(type, detail, options) {
    if (typeof type === 'string') {
      type = new CustomEvent(type, _objectSpread({
        detail: detail
      }, options !== null && options !== void 0 ? options : {}));
    }

    return eventTarget.dispatchEvent(type);
  };

  return {
    on: on,
    addEventListener: on,
    off: off,
    removeEventListener: off,
    emit: emit,
    dispatchEvent: emit,
    '☠️☠️☠️___FOR_TESTING_ONLY_DO_NOT_USE': eventTarget
  };
}

var _window$Lue_original, _window$Lue_original2;

var extrasKey = _Symbol('blue-xhr-extras');

var _ref = (_window$Lue_original = window.Ɓlue_originals_injected) !== null && _window$Lue_original !== void 0 ? _window$Lue_original : XMLHttpRequest.prototype,
    open = _ref.open,
    setRequestHeader = _ref.setRequestHeader,
    send = _ref.send;

var emitter = eventEmitter();
function originalSetHeader(xhr, header, value) {
  return get(setRequestHeader).call(xhr, header, value);
}
function originalSend(xhr, body) {
  return get(send).call(xhr, body);
}
function originalOpen(xhr, method, url) {
  var async = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var username = arguments.length > 4 ? arguments[4] : undefined;
  var password = arguments.length > 5 ? arguments[5] : undefined;
  return get(open).call(xhr, method, url, async, username, password);
}

var setHeaderOverride = function setHeaderOverride(header, value) {
  var extras = this[extrasKey] || {};

  if (emitter.emit('set-header', _objectSpread({
    header: header,
    value: value,
    xhr: this
  }, extras), {
    cancelable: true
  })) {
    return get(setRequestHeader).call(this, header, value);
  }
};

var sendOverride = function sendOverride(body) {
  var extras = this[extrasKey] || {};

  if (emitter.emit('send', _objectSpread({
    body: body,
    xhr: this
  }, extras), {
    cancelable: true
  })) {
    return get(send).call(this, body);
  }
};

var openOverride = function openOverride(method, url, async, username, password) {
  this[extrasKey] = {
    method: method,
    url: url,
    async: async,
    username: username,
    password: password
  };
  async = async === undefined || async === null ? true : async;

  if (emitter.emit('pre-open', {
    method: method,
    url: url,
    async: async,
    username: username,
    password: password,
    xhr: this
  }, {
    cancelable: true
  })) {
    var result = get(open).call(this, method, url, async, username, password);
    emitter.emit('post-open', {
      method: method,
      url: url,
      async: async,
      username: username,
      password: password,
      xhr: this
    }, {
      cancelable: true
    });
    return result;
  }
};

window.Ɓlue_originals_injected = (_window$Lue_original2 = window.Ɓlue_originals_injected) !== null && _window$Lue_original2 !== void 0 ? _window$Lue_original2 : {
  setRequestHeader: setRequestHeader,
  send: send,
  open: open
};
XMLHttpRequest.prototype.setRequestHeader = setHeaderOverride;
XMLHttpRequest.prototype.send = sendOverride;
XMLHttpRequest.prototype.open = openOverride;

var preInterceptors = [];
var postInterceptors = [];

function executeInterceptors(event, interceptors) {
  var _event$detail = event.detail,
      xhr = _event$detail.xhr,
      method = _event$detail.method,
      url = _event$detail.url,
      async = _event$detail.async,
      username = _event$detail.username,
      password = _event$detail.password;

  _forEachInstanceProperty(interceptors).call(interceptors, function (int) {
    if (isAllowed(getDomainFromURL(url), int)) {
      int.resource.call(xhr, method, url, async, username, password);
    }
  });
}

function addInterceptor(interceptors, fn, domainAllowList) {
  interceptors.push({
    resource: fn,
    domainAllowList: domainAllowList
  });
  return function () {
    var int = _findInstanceProperty(interceptors).call(interceptors, function (int) {
      return int.resource === fn;
    });

    if (int) {
      _spliceInstanceProperty(interceptors).call(interceptors, _indexOfInstanceProperty(interceptors).call(interceptors, int), 1);
    }
  };
}

emitter.on('pre-open', function (event) {
  return executeInterceptors(event, preInterceptors);
});
emitter.on('post-open', function (event) {
  return executeInterceptors(event, postInterceptors);
});
function addPreInterceptor(fn, domainAllowList) {
  return addInterceptor(preInterceptors, fn, domainAllowList);
}
function addPostInterceptor(fn, domainAllowList) {
  return addInterceptor(postInterceptors, fn, domainAllowList);
}

function injectEvent(type, cb, domainAllowList) {
  return addPreInterceptor(function (method, url, async, user, password) {
    var _cb = function _cb(evt) {
      cb.call(this, evt, method, url, async, user, password);
    };

    this.addEventListener(type, _cb);
  }, domainAllowList);
}

var hasOwnProp = function hasOwnProp(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
};

var headerStore = _Symbol('inject-xhr-headers');

var headersSets$1 = [];

function resolveHeaderValue$1(value, extras, request, currentHeaders) {
  return typeof value === 'function' ? value(extras.url, _objectSpread(_objectSpread({}, extras), {}, {
    request: request
  }), currentHeaders) : value;
}

emitter.on('set-header', function (event) {
  var _context;

  var _event$detail = event.detail,
      header = _event$detail.header,
      value = _event$detail.value,
      xhr = _event$detail.xhr;
  var ctx = xhr;
  var h = header.toLowerCase();
  var headers = ctx[headerStore] || {};
  headers[h] = _filterInstanceProperty(_context = [headers[h], value]).call(_context, function (v) {
    return v;
  }).join(', ');
  ctx[headerStore] = headers;
  event.preventDefault();
});

function assignHeaderValue(headers, key, value) {
  if (value !== null && value !== undefined) {
    headers[key] = value;
  } else if (value === null) {
    delete headers[key];
  }
}

function resolveHeader(headers, key, rawValue, xhr, extras) {
  var h = key.toLowerCase();
  var value = resolveHeaderValue$1(rawValue, extras, xhr, headers);
  assignHeaderValue(headers, h, value);
}

emitter.on('send', function (event) {
  var _event$detail2 = event.detail,
      xhr = _event$detail2.xhr,
      url = _event$detail2.url,
      method = _event$detail2.method,
      async = _event$detail2.async;
  var currentHeaders = xhr[headerStore] || {};

  var headersSetsToApply = _filterInstanceProperty(headersSets$1).call(headersSets$1, function (set) {
    return isAllowed(getDomainFromURL(url), set);
  });

  var _iterator = _createForOfIteratorHelper(headersSetsToApply),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var set = _step.value;

      for (var _key2 in set.resource) {
        if (hasOwnProp(set.resource, _key2)) {
          resolveHeader(currentHeaders, _key2, set.resource[_key2], xhr, {
            url: url,
            method: method,
            async: async
          });
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  for (var _key in currentHeaders) {
    if (hasOwnProp(currentHeaders, _key) && currentHeaders[_key]) {
      originalSetHeader(xhr, _key, currentHeaders[_key]);
    }
  }
});

var isEmpty$1 = function isEmpty(obj) {
  return obj === undefined || obj === null || _Object$keys(obj).length === 0;
};

function injectXhrHeaders(headers, domainAllowList) {
  if (isEmpty$1(headers)) {
    return noop;
  }

  headersSets$1.push({
    resource: headers,
    domainAllowList: domainAllowList
  });
  return function () {
    var headersSet = _findInstanceProperty(headersSets$1).call(headersSets$1, function (int) {
      return int.resource === headers;
    });

    if (headersSet) {
      _spliceInstanceProperty(headersSets$1).call(headersSets$1, _indexOfInstanceProperty(headersSets$1).call(headersSets$1, headersSet), 1);
    }
  };
}

function injectHeaders(headers, domainAllowList) {
  var unregisterFetch = injectFetchHeaders(headers, domainAllowList);
  var unregisterXHR = injectXhrHeaders(headers, domainAllowList);
  return function () {
    unregisterFetch();
    unregisterXHR();
  };
}

function normalizeFetchResolve(_res, _req) {
  return {
    req: {
      method: _req.method,
      url: _req.url
    },
    res: _res
  };
}

function normalizeFetchReject(_err, _req) {
  return {
    req: {
      method: _req.method,
      url: _req.url
    },
    err: _err
  };
}

function normalizeXhrHeaders(xhr) {
  var _context, _context2, _context3;

  var headers = _reduceInstanceProperty(_context = _filterInstanceProperty(_context2 = _mapInstanceProperty(_context3 = xhr.getAllResponseHeaders().split('\n')).call(_context3, function (header) {
    return header.split(': ');
  })).call(_context2, function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return Boolean(key) && Boolean(value);
  })).call(_context, function (out, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];

    out[key] = value;
    return out;
  }, {});

  return new Headers(headers);
}

function normalizeXhrResolve(_eventMap, xhr, method, requestUrl) {
  return {
    req: {
      method: method,
      url: requestUrl
    },
    res: {
      status: xhr.status,
      statusText: xhr.statusText,
      headers: normalizeXhrHeaders(xhr),
      url: xhr.responseURL
    }
  };
}

function normalizeXhrReject(_eventMap, method, url) {
  var req = {
    method: method,
    url: url
  };
  var err = new TypeError('XHR failed to retrieve resource');
  return {
    req: req,
    err: err
  };
}

function addFetchResolveInterceptor(cb, domainAllowList) {
  return addResolveInterceptor(function (_res, _req) {
    var _normalizeFetchResolv = normalizeFetchResolve(_res, _req),
        req = _normalizeFetchResolv.req,
        res = _normalizeFetchResolv.res;

    cb(req, res);
  }, domainAllowList);
}
function addFetchRejectInterceptor(cb, domainAllowList) {
  return addRejectInterceptor(function (_err, _req) {
    var _normalizeFetchReject = normalizeFetchReject(_err, _req),
        req = _normalizeFetchReject.req,
        err = _normalizeFetchReject.err;

    cb(req, err);
  }, domainAllowList);
}
function addXhrResolveInterceptor(cb, domainAllowList) {
  return injectEvent('load', function (_xmlHttpRequestEventMap, method, requestUrl) {
    var _normalizeXhrResolve = normalizeXhrResolve(_xmlHttpRequestEventMap, this, method, requestUrl),
        req = _normalizeXhrResolve.req,
        res = _normalizeXhrResolve.res;

    cb(req, res);
  }, domainAllowList);
}
function addXhrRejectInterceptor(cb, domainAllowList) {
  var unregisterXhrRejectCallback = injectEvent('error', function (_xmlHttpRequestEventMap, method, requestUrl) {
    var _normalizeXhrReject = normalizeXhrReject(_xmlHttpRequestEventMap, method, requestUrl),
        req = _normalizeXhrReject.req,
        err = _normalizeXhrReject.err;

    cb(req, err);
  }, domainAllowList);
  var unregisterXhrAbortCallback = injectEvent('abort', function (_xmlHttpRequestEventMap, method, url) {
    var _normalizeXhrReject2 = normalizeXhrReject(_xmlHttpRequestEventMap, method, url),
        req = _normalizeXhrReject2.req,
        err = _normalizeXhrReject2.err;

    cb(req, err);
  }, domainAllowList);
  return function () {
    unregisterXhrRejectCallback();
    unregisterXhrAbortCallback();
  };
}

function addNetResolveInterceptor(cb, domainAllowList) {
  var unregisterFetchResolveInterceptor = addFetchResolveInterceptor(cb, domainAllowList);
  var unregisterXhrResolveInterceptor = addXhrResolveInterceptor(cb, domainAllowList);
  return function () {
    unregisterFetchResolveInterceptor();
    unregisterXhrResolveInterceptor();
  };
}
function addNetRejectInterceptor(cb, domainAllowList) {
  var unregisterFetchRejectInterceptor = addFetchRejectInterceptor(cb, domainAllowList);
  var unregisterXhrRejectInterceptor = addXhrRejectInterceptor(cb, domainAllowList);
  return function () {
    unregisterFetchRejectInterceptor();
    unregisterXhrRejectInterceptor();
  };
}
function addNetFinallyInterceptor(resolveCb, rejectCb, domainAllowList) {
  var unregisterNetResolveCallback = addNetResolveInterceptor(resolveCb, domainAllowList);
  var unregisterNetRejectCallback = addNetRejectInterceptor(rejectCb, domainAllowList);
  return function () {
    unregisterNetResolveCallback();
    unregisterNetRejectCallback();
  };
}

function addHttpResolveInterceptor(cb, domainAllowList) {
  return addNetResolveInterceptor(function (req, res) {
    if (res.status < 400) {
      cb(req, res);
    }
  }, domainAllowList);
}
function addHttpRejectInterceptor(cb, domainAllowList) {
  return addNetResolveInterceptor(function (req, res) {
    if (res.status >= 400) {
      cb(req, res);
    }
  }, domainAllowList);
}

var HttpStatusCodes;

(function (HttpStatusCodes) {
  HttpStatusCodes[HttpStatusCodes["continue"] = 100] = "continue";
  HttpStatusCodes[HttpStatusCodes["switchingProtocols"] = 101] = "switchingProtocols";
  HttpStatusCodes[HttpStatusCodes["processing"] = 102] = "processing";
  HttpStatusCodes[HttpStatusCodes["ok"] = 200] = "ok";
  HttpStatusCodes[HttpStatusCodes["created"] = 201] = "created";
  HttpStatusCodes[HttpStatusCodes["accepted"] = 202] = "accepted";
  HttpStatusCodes[HttpStatusCodes["nonAuthoritativeInformation"] = 203] = "nonAuthoritativeInformation";
  HttpStatusCodes[HttpStatusCodes["noContent"] = 204] = "noContent";
  HttpStatusCodes[HttpStatusCodes["resetContent"] = 205] = "resetContent";
  HttpStatusCodes[HttpStatusCodes["partialContent"] = 206] = "partialContent";
  HttpStatusCodes[HttpStatusCodes["multiStatus"] = 207] = "multiStatus";
  HttpStatusCodes[HttpStatusCodes["alreadyReported"] = 208] = "alreadyReported";
  HttpStatusCodes[HttpStatusCodes["imUsed"] = 226] = "imUsed";
  HttpStatusCodes[HttpStatusCodes["multipleChoices"] = 300] = "multipleChoices";
  HttpStatusCodes[HttpStatusCodes["movedPermanently"] = 301] = "movedPermanently";
  HttpStatusCodes[HttpStatusCodes["found"] = 302] = "found";
  HttpStatusCodes[HttpStatusCodes["seeOther"] = 303] = "seeOther";
  HttpStatusCodes[HttpStatusCodes["notModified"] = 304] = "notModified";
  HttpStatusCodes[HttpStatusCodes["useProxy"] = 305] = "useProxy";
  HttpStatusCodes[HttpStatusCodes["temporaryRedirect"] = 307] = "temporaryRedirect";
  HttpStatusCodes[HttpStatusCodes["permanentRedirect"] = 308] = "permanentRedirect";
  HttpStatusCodes[HttpStatusCodes["badRequest"] = 400] = "badRequest";
  HttpStatusCodes[HttpStatusCodes["unauthorized"] = 401] = "unauthorized";
  HttpStatusCodes[HttpStatusCodes["paymentRequired"] = 402] = "paymentRequired";
  HttpStatusCodes[HttpStatusCodes["forbidden"] = 403] = "forbidden";
  HttpStatusCodes[HttpStatusCodes["notFound"] = 404] = "notFound";
  HttpStatusCodes[HttpStatusCodes["methodNotAllowed"] = 405] = "methodNotAllowed";
  HttpStatusCodes[HttpStatusCodes["notAcceptable"] = 406] = "notAcceptable";
  HttpStatusCodes[HttpStatusCodes["proxyAuthenticationRequired"] = 407] = "proxyAuthenticationRequired";
  HttpStatusCodes[HttpStatusCodes["requestTimeout"] = 408] = "requestTimeout";
  HttpStatusCodes[HttpStatusCodes["conflict"] = 409] = "conflict";
  HttpStatusCodes[HttpStatusCodes["gone"] = 410] = "gone";
  HttpStatusCodes[HttpStatusCodes["lengthRequired"] = 411] = "lengthRequired";
  HttpStatusCodes[HttpStatusCodes["preconditionFailed"] = 412] = "preconditionFailed";
  HttpStatusCodes[HttpStatusCodes["payloadTooLarge"] = 413] = "payloadTooLarge";
  HttpStatusCodes[HttpStatusCodes["uriTooLong"] = 414] = "uriTooLong";
  HttpStatusCodes[HttpStatusCodes["unsupportedMediaType"] = 415] = "unsupportedMediaType";
  HttpStatusCodes[HttpStatusCodes["requestedRangeNotSatisfiable"] = 416] = "requestedRangeNotSatisfiable";
  HttpStatusCodes[HttpStatusCodes["expectationFailed"] = 417] = "expectationFailed";
  HttpStatusCodes[HttpStatusCodes["unprocessableEntity"] = 422] = "unprocessableEntity";
  HttpStatusCodes[HttpStatusCodes["locked"] = 423] = "locked";
  HttpStatusCodes[HttpStatusCodes["failedDependency"] = 424] = "failedDependency";
  HttpStatusCodes[HttpStatusCodes["upgradeRequired"] = 426] = "upgradeRequired";
  HttpStatusCodes[HttpStatusCodes["preconditionRequired"] = 428] = "preconditionRequired";
  HttpStatusCodes[HttpStatusCodes["tooManyRequests"] = 429] = "tooManyRequests";
  HttpStatusCodes[HttpStatusCodes["requestHeaderFieldsTooLarge"] = 431] = "requestHeaderFieldsTooLarge";
  HttpStatusCodes[HttpStatusCodes["internalServerError"] = 500] = "internalServerError";
  HttpStatusCodes[HttpStatusCodes["notImplemented"] = 501] = "notImplemented";
  HttpStatusCodes[HttpStatusCodes["badGateway"] = 502] = "badGateway";
  HttpStatusCodes[HttpStatusCodes["serviceUnavailable"] = 503] = "serviceUnavailable";
  HttpStatusCodes[HttpStatusCodes["gatewayTimeout"] = 504] = "gatewayTimeout";
  HttpStatusCodes[HttpStatusCodes["httpVersionNotSupported"] = 505] = "httpVersionNotSupported";
  HttpStatusCodes[HttpStatusCodes["variantAlsoNegotiates"] = 506] = "variantAlsoNegotiates";
  HttpStatusCodes[HttpStatusCodes["insufficientStorage"] = 507] = "insufficientStorage";
  HttpStatusCodes[HttpStatusCodes["loopDetected"] = 508] = "loopDetected";
  HttpStatusCodes[HttpStatusCodes["notExtended"] = 510] = "notExtended";
  HttpStatusCodes[HttpStatusCodes["networkAuthenticationRequired"] = 511] = "networkAuthenticationRequired";
})(HttpStatusCodes || (HttpStatusCodes = {}));

var version = "8.5.1";
var name = "@onviobr/net-utils";
registerLibrary({
  version: version,
  name: name
});

export { HttpStatusCodes, addFetchRejectInterceptor, addFetchResolveInterceptor, addHttpRejectInterceptor, addHttpResolveInterceptor, addInputInterceptor, addNetFinallyInterceptor, addNetRejectInterceptor, addNetResolveInterceptor, addPostInterceptor, addPreInterceptor, addRejectInterceptor, addRequestInterceptor, addResolveInterceptor, addXhrRejectInterceptor, addXhrResolveInterceptor, emitter, eventEmitter, injectEvent, injectFetchHeaders, injectHeaders, injectXhrHeaders, isAllowed, isIntercepted, originalOpen, originalSend, originalSetHeader };
